import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'displayDonneesRef',
  standalone: false,
})
export class DisplayDonneesRefPipe implements PipeTransform {
  constructor(readonly translateService: TranslateService) {}

  transform(value: string[], ref?: string): string[] {
    return value.sort((a, b) => {
      let strA = a;
      let strB = b;
      if (ref) {
        strA = this.translateService.instant(`${ref}${a}`);
        strB = this.translateService.instant(`${ref}${b}`);
      }
      strA = strA.toLowerCase();
      strB = strB.toLowerCase();
      return strA.localeCompare(strB);
    });
  }
}

export default DisplayDonneesRefPipe;
